<template>
  <div class="container">
    <a-modal
      class="gufiiguy"
      title="新增岗位"
      :visible="addPostVisible"
      @cancel="closeAddPost"
      width="70%"
      @ok="addPost"
    >
      <div class="title">
        <span>基本信息</span>
      </div>
      <div class="postTop">
        <a-form-model
          :model="addPostForm"
          :rules="rules"
          ref="addPostFormRef"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 18 }"
        >
          <a-row>
            <a-col :span="8">
              <a-form-model-item label="企业名称" prop="">
                <span>{{ propRowData.companyName }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="项目名称" prop="">
                <span>{{ categoryData1.fullCategory }}</span>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item
                label="岗位名称"
                prop=""
                :rules="{
                  required: true,
                  message: '请选择岗位名称',
                  trigger: 'change',
                }"
              >
                <a-select
                  allowClear
                  placeholder="请选择岗位"
                  v-model="addPostForm.postName"
                  show-search
                  :filter-option="filterOption"
                  @change="getcheckedItem"
                >
                  <!-- v-model="informationList.categoryName"
                  @change="changeCategory" -->
                  <a-select-option :value="item.id" v-for="(item, index) in postList" :key="index">
                    {{ item.postName }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="8">
              <a-form-model-item
                label="点位数"
                prop="pointNumber"
                :rules="{
                  required: true,
                  message: '请输入点位数',
                  trigger: 'change',
                }"
              >
                <a-input
                  v-model="addPostForm.pointNumber"
                  allowClear
                  class="a_input_self margin_self"
                  placeholder="请输入"
                />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
      <div class="center">
        <span>检测项目</span>
        <a-button type="primary" @click="addCategory" style="margin-right: 5px" :disabled="!addPostForm.postName"
          >添加其他危害因素</a-button
        >
      </div>
      <div class="postBottom">
        <a-table
          :pagination="false"
          :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
          :columns="columns"
          :data-source="productsList"
        >
          <span slot="index" slot-scope="text, record, index">
            {{ index + 1 }}
          </span>
        </a-table>
      </div>
    </a-modal>
    <addOtherPost ref="addOtherPost" @addOtherIndustry="addOtherIndustry"></addOtherPost>
  </div>
</template>

<script>
import addOtherPost from './addOtherPost.vue'
import { getItems, getFactorDetail, addQuoteSheetItemsBatch, postInfo_list } from '@/api/Industry'
export default {
  components: {
    addOtherPost,
  },
  props: ['addPostVisible', 'propRowData', 'categoryData1', 'postList', 'UUID', 'multiple', 'industryId'],

  data() {
    return {
      sheetItemsDTOList: {},
      selectedRowKeys: '',
      val: [],
      productsList: [],
      addPostForm: {
        pointNumber: '',
      },
      columns: [
        {
          title: '序号',
          dataIndex: 'index',
          scopedSlots: {
            customRender: 'index',
          },
        },
        {
          title: '检测项目',
          dataIndex: 'factorName',
        },
        {
          title: '单价',
          dataIndex: 'price',
        },
        {
          title: '检测标准',
          dataIndex: 'standardInfo',
        },
      ],
    }
  },
  methods: {
    addOtherIndustry(data) {
        this.productsList = [...this.productsList,...data]

    },
    //添加其他危害因素
    addCategory() {
      var data = {
        postId: this.addPostForm.postId,
        sheetId: this.UUID,
        subId: this.categoryData1.id,
      }
      console.log(this.$refs, 'this.$refs=====================')
      this.$nextTick(() => {
        this.$refs.addOtherPost.init(data)
      })
    },
    //提交弹窗数据
    addPost() {
      // 表单校验
      this.$refs.addPostFormRef.validate((valid) => {
        if (valid) {
          if (this.val.length == 0) {
            this.$message.warning('请选择检测项目！')
          } else {
            this.val.forEach((item) => {
              var totalPrice
              totalPrice = item.price * this.addPostForm.pointNumber * this.multiple
              Object.assign(item, {
                totalPrice: totalPrice,
                pointNumber: this.addPostForm.pointNumber,
                selectedRowKeys: this.selectedRowKeys,
                postId: this.addPostForm.postId,
              })
            })
            this.sheetItemsDTOList = this.val

            //  for(var i = 0; i < this.val.length; i++ ) {
            //  let list = {}
            //  Object.assign( this.sheetItemsDTOList,{
            //      selectedRowKeys: this.selectedRowKeys,

            // factorName: this.val[i].factorName,
            // price: this.val[i].price,
            // standardInfo: this.val[i].standardInfo
            //  })
            //   this.sheetItemsDTOList.push(list)
            //   console.log( this.sheetItemsDTOList, ' this.sheetItemsDTOList=========================')

            //  }
            // this.sheetItemsDTOList = this.val
            // this.val.forEach(item => {
            //     Object.assign( this.sheetItemsDTOList,{
            //      pointNumber: this.addPostForm.pointNumber,
            //  })

            // })

            //   this.$emit("postDataList", this.sheetItemsDTOList)

            addQuoteSheetItemsBatch({
              postId: this.addPostForm.postId,
              sheetId: this.UUID,
              postName: this.addPostForm.postName,
              subId: this.categoryData1.id,
              subName: this.categoryData1.fullCategory,
              quoteBaseFactorVOList: this.sheetItemsDTOList,
            }).then((res) => {
              if (res.code == 200) {
                this.$emit('postDataList', {
                  postName: this.addPostForm.postName,
                  selectedRowKeys: this.selectedRowKeys,
                  val: this.val,
                  pointNumber: this.addPostForm.pointNumber,
                })
                console.log(this.categoryData1, 'this.categoryData1')
                this.addPostVisible = false
                this.val = []
                this.selectedRowKeys = ''
                this.addPostForm.pointNumber = ''
                this.addPostForm.postName = ''
                this.productsList = []
                // this.$refs.addPostFormRef.resetFields()
                this.$emit('addVisibleState', this.addPostVisible)
                console.log(res, 'res66666666666666')
              }
            })
          }
        }
      })
    },
    //获取检测项目列表
    getcheckedItem(e) {
      this.selectedRowKeys = ''
      this.postList.forEach((item) => {
        if (item.id == e) {
          this.addPostForm.postName = item.postName
          this.addPostForm.postId = item.id
        }
      })
      getFactorDetail({
        postId: e,
        subId: this.categoryData1.id,
      }).then((res) => {
        console.log(res, 'res66666666666666')
        this.productsList = res.data
      })
      // getItems({
      //     sheetId: this.UUID,
      //     postName: this.addPostForm.postName
      // }).then(res => {
      //     console.log(res, 'res66666666666666')
      // })
    },
    //下拉搜索
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    closeAddPost() {
      this.addPostVisible = false
      this.$emit('addVisibleState', this.addPostVisible)
      this.val = []
      this.selectedRowKeys = ''
      this.addPostForm.pointNumber = ''
      this.addPostForm.postName = undefined
      this.productsList = []
      //清空表单
      // this.$refs.addPostFormRef.resetFields()
    },
    onSelectChange(selectedRowKeys, val) {
      console.log(selectedRowKeys, val)
      this.selectedRowKeys = selectedRowKeys
      this.val = val
      // this.transferVal = val
      // this.dataVal = val
    },
  },
}
</script>

<style>
.container {
  background-color: #f8f8f8;
}
.title {
  font-size: 18px;
  padding: 5px 10px;
  margin: 10px 10px;
}
.center {
  font-size: 18px;
  padding: 5px 10px;
  margin: 10px 10px;
  display: flex;
  justify-content: space-between;
}
.postTop,
.postBottom {
  background-color: #fff;
  margin: 5px 10px;
  border-radius: 15px;
}
</style>